// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"copy-text-bar_wrapper__EQaGw","text_wrapper":"copy-text-bar_text_wrapper___8iNz","copy_button_wrapper":"copy-text-bar_copy_button_wrapper__b9_V9"};